module.exports = __webpack_public_path__ + "img/table.a12292f4.png";